/*
 * RisoLab Calendar Carousel
 */
import Flickity from 'flickity/dist/flickity.pkgd.js';

jQuery(document).ready(function($) {
    let flkty;

    // Get carousel element
    let elem = document.querySelector('.calendar-carousel');
    let btns = $('.calendar-nav button');

    if(elem){
        let options = {
            cellAlign: 'center',
            contain: true,
            wrapAround: true,
            pageDots: false,
            on:{
                ready: function(){
                    btns.on('click', function(e) {
                        e.preventDefault();
                        const t = $(this);
                        const idx = t.index();

                        flkty.selectCell( idx );
                    });

                    if(flkty){
                        flkty.reloadCells();
                    }
                },
                change: function(idx){
                    btns.removeClass('active').eq(idx).addClass('active');
                }
            }
        }

        flkty = new Flickity( elem, options);
    }

    var myCalendarDC = $A.setDatepicker({
        id: "ReservationDateSelector",
        input: "#field_dateselector",
        toggle: "#date-picker-btn",
    });


    // Reservation Calendar Tabs
    const buttons = document.querySelectorAll('.tab');

    buttons.forEach(button => {
        button.addEventListener('click', function () {
            // Remove active class from all sections and buttons
            document.querySelectorAll('.appointment-form').forEach(div => {
                div.classList.remove('active');
            });
            document.querySelectorAll('.tab').forEach(tab => {
                tab.classList.remove('active');
            });
            // Add active class to the selected section and button
            const index = this.getAttribute('data-index');

            document.getElementById(`appointment-${index}`).classList.add('active');
            this.classList.add('active');

            // Set focus to the corresponding div for better accessibility
            document.getElementById(`appointment-${index}`).focus();
        });
    });
});